<template>
  <div id="fenceMapwrap">
    <div id="searchAdd" v-if="isSearch">
      <search-add @adds="reAdds"></search-add>
    </div>
    <div id="searchCar1" v-if="isSearchCar">
      <searchLocateByCar @adds="reAdds"></searchLocateByCar>
    </div>
    <div id="fenceTools">
      <ButtonGroup vertical>
        <Button
          :type="isSearch ? 'primary' : 'default'"
          icon="ios-search"
          title="搜索位置"
          @click="isSearch = !isSearch"
        ></Button>
        <Button
          @click="isSearchCar = !isSearchCar"
          :type="isSearchCar ? 'primary' : 'default'"
          icon="md-car"
          title="通过车牌找位置"
        ></Button>
        <Button icon="ios-disc" title="绘制" @click="fenceDraw"></Button>
        <Button icon="ios-open" title="编辑" @click="fenceEdit"></Button>
        <Button
          icon="md-radio-button-on"
          title="行政区域"
          @click="openForm = true"
        ></Button>
        <Tooltip placement="right" max-width="330">
          <Button icon="md-help"></Button>
          <template #content>
            <div style="width: 300px">
              <h3 style="margin-bottom: 10px">如何绘制</h3>
              <i
                >先选择‘开始绘制’工具（鼠标放在按钮上有提示），在需要绘制的点上单击，双击结束</i
              >
              <h3 style="margin-bottom: 10px; margin-top: 20px">如何修改</h3>
              <i>先选择‘开始编辑’工具，拖动边上的小圆圈即可</i>
            </div>
          </template>
        </Tooltip>
      </ButtonGroup>
    </div>
    <div id="fenceMap"></div>
    <Modal
      v-model="openForm"
      title="行政区域绘制"
      footer-hide
      draggable
      width="340"
      :mask="true"
    >
      <Form
        :label-width="80"
        ref="autoItem"
        :model="autoItem"
        :rules="ruleValidate"
      >
        <FormItem label="区域名称" prop="district">
          <Input
            placeholder="请输入行政区域"
            v-model="autoItem.district"
            clearable
          ></Input>
        </FormItem>
        <FormItem label="区域类型" prop="type">
          <Select v-model="autoItem.type">
            <Option value="district">区/县/县级市</Option>
            <Option value="city">市/特别行政区</Option>
            <Option value="province">省/直辖市/自治区</Option>
          </Select>
        </FormItem>
      </Form>

      <Row type="flex" justify="end">
        <Col span="24">
          <div class="btn-wrap">
            <Button type="primary" @click="xingchegnquyu('autoItem')"
              >生成区域</Button
            >
          </div>
        </Col>
      </Row>
    </Modal>
  </div>
</template>
<script>
var map;
var mouseTool;
var path = [];
var polygon;
var district = null;
import searchLocateByCar from "../rule/searchLocateByCar.vue";
export default {
  components: { searchLocateByCar },
  data() {
    return {
      center: [114, 24],
      openForm: false,

      autoItem: {
        district: "北京",
        type: "district",
      },
      ruleValidate: {
        district: { required: true, message: "必填项" },
      },
      isSearch: false,
      isSearchCar: false,
    };
  },
  methods: {
    loadMap() {
      map = new AMap.Map("fenceMap", {
        resizeEnable: true,
        center: this.center,
        zoom: 10,
      });
      map.on("complete", function (ev) {
        mouseTool = new AMap.MouseTool(map);
      });
    },

    drawDefaulFence() {
      //原有的图形;
      this.fenceClear();
      polygon = new AMap.Polygon({
        path: path,
        strokeWeight: 6,
        strokeOpacity: 0.2,
        fillOpacity: 0.4,
        //fillColor: "#309ef8",
        fillColor: "green",
        zIndex: 50,
      });
      map.add(polygon);
      map.setFitView([polygon]);
    },
    //接收编辑数据并转化
    reData(m) {
      path = [];
      for (let j = 0; j < m.length; j++) {
        var arrParent = [];
        for (let i = 0; i < m[j].length; i++) {
          var arr = [m[j][i].x, m[j][i].y];
          arrParent.push(arr);
        }
        path.push(arrParent);
      }
      setTimeout(() => {
        this.drawDefaulFence();
      }, 500);
    },
    fenceClose() {
      map.setDefaultCursor("");
      if (this._polygonEditor) {
        this._polygonEditor.close();
      }
    },
    fenceClear() {
      var polyArr = map.getAllOverlays("polygon");
      map.remove(polyArr);
    },
    fenceDraw() {
      map.setDefaultCursor("crosshair");
      mouseTool.close(true);
      this.fenceClear();
      mouseTool.polygon({
        //fillColor: "#00b0ff",
        fillColor: "green",
        strokeColor: "#80d8ff",
        strokeWeight: 4,
        //同Polygon的Option设置
      });

      var that = this;
      // mouseTool.polygon();
      mouseTool.on("draw", function (event) {
        map.setDefaultCursor("");
        // event.obj 为绘制出来的覆盖物对象
        path = [event.obj.getPath()]; //取得绘制的多边形的每一个点坐标
        that.drawDefaulFence();
      });
    },
    getPoints() {
      if (!polygon) {
        this.$Message.error("请绘制网格");
        return;
      }
      this.fenceClose();
      //对参数进行转换
      var myPath = polygon.getPath();
      var ver = [];
      for (let i = 0; i < myPath.length; i++) {
        var arr = [];
        for (let j = 0; j < myPath[i].length; j++) {
          var obj = {
            x: myPath[i][j].lng,
            y: myPath[i][j].lat,
          };
          arr.push(obj);
        }
        ver.push(arr);
      }
      path = [];
      return ver;
    },
    fenceEdit() {
      if (path.length == 0) {
        this.$Message.error("无可编辑网格");
        return;
      }
      this.fenceClear();
      this.drawDefaulFence();
      map.setDefaultCursor("crosshair");
      if (path.length == 0) {
        return;
      }
      this._polygonEditor = new AMap.PolyEditor(
        map,
        map.getAllOverlays("polygon")[0]
      );
      //注意通过map.getAllOverlays("polygon")对象获得的是一个数组，故取数组第一个对象
      this._polygonEditor.open();
    },
    reAdds(v) {
      this.center = [v.x, v.y];
      map.panTo(this.center);
      map.setZoom(17);
    },
    drawBounds(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          var that = this;
          //加载行政区划插件
          if (!district) {
            //实例化DistrictSearch
            var opts = {
              subdistrict: 0, //获取边界不需要返回下级行政区
              extensions: "all", //返回行政区边界坐标组等具体信息
              level: "district", //查询行政级别为 市
            };
            district = new AMap.DistrictSearch(opts);
          }
          //行政区查询
          district.setLevel(this.autoItem.type);
          district.search(this.autoItem.district, function (status, result) {
            console.log("行政区域", result);
            map.remove(path); //清除上次结果
            path = [];
            if (status == "no_data") {
              that.$Message.error({
                content: "未找到区域，请换个行政名称试试",
                duration: 3,
              });
              return;
            }
            var bounds = result.districtList[0].boundaries;
            if (bounds) {
              for (var i = 0, l = bounds.length; i < l; i++) {
                path.push(bounds[i]);
              }
              that.drawDefaulFence();
              that.openForm = false;
            }
          });
        }
      });
    },
    xingchegnquyu() {
      AMap.plugin("AMap.DistrictSearch", function () {
        var districtSearch = new AMap.DistrictSearch({
          level: "biz area", //关键字对应的行政区级别，country 表示国家
          subdistrict: 3, //显示下级行政区级数，1表示返回下一级行政区
          //extensions: 'all', //返回行政区边界坐标组等具体信息
        });
        //搜索所有省、直辖市信息
        districtSearch.search("中国", function (status, result) {
          console.log(status, result);
          //status：complete 表示查询成功，no_data 为查询无结果，error 代表查询错误
          //查询成功时，result 即为对应的行政区信息
        });
      });
    },
    destroyMap() {
      map && map.destroy();
    },
  },
  mounted() {
    //this.loadMap();
  },
};
</script>
<style lang="">
#searchAdd {
  position: absolute;
  background: #ccc;
  z-index: 2;
  top: 10px;
  left: 50px;
}
#fenceMapwrap {
  width: 100%;
  height: 100%;
  background: #cccf;
  position: relative;
}
#fenceMap {
  width: 100%;
  height: 100%;
}
#fenceTools {
  position: absolute;
  background: #ccc;
  z-index: 2;
  top: 10px;
  left: 10px;
}
#searchCar1 {
  position: absolute;
  background: #ccc;
  z-index: 22;
  top: 40px;
  left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/map/duobianxing.vue